<template>
  <popup-layout :title="selectData.text" :is-show="isShow" width="80vw" max-width="500px">
    <template v-slot:content>
      <v-flex>
        <div class="sub-title-layout">
          <span class="sub-title">증명서신청에 필요한 정보를 입력해주세요</span>
        </div>
        <v-row class="input-container">
          <field-input title="연도" cols="1" v-if="selectData.value === '소득자료증명서'">
            <v-select
              v-model="yyyy"
              :items="yearList"
              item-text="text"
              item-value="value"
              placeholder="선택해주세요"
              outlined hide-details dense
              background-color="white"
            />
          </field-input>
          <field-input title="용 도" cols="1">
            <v-select
              v-model="usage"
              :items="usageList"
              item-text="text"
              item-value="value"
              placeholder="선택해주세요"
              outlined hide-details dense
              background-color="white"
            />
          </field-input>
          <field-input title="메모" cols="1" v-if="selectData.value === '경력증명서'">
            <v-text-field
              v-model="submitPlace"
              outlined hide-details dense
              background-color="white"
            />
          </field-input>
        </v-row>
      </v-flex>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button save" outlined @click="save">
          완료
        </v-btn>
        <v-btn class="button delete" outlined @click="close">
          닫기
        </v-btn>
      </div>
    </template>
  </popup-layout>
</template>
<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import TableMixin from "@/mixin/TableMixin";
import constant from "@/util/constant";
import FieldInput from "@/common/components/input/FieldInput.vue";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "CertificateSignup",
  components: {FieldInput, PopupLayout},
  props: ["isShow", "selectData"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      certificateTypeList: constant.CERTIFICATE_TYPE_LIST,
      yyyy: "",
      yearList: [],
      usage: "",
      usageList: [
        { text: "기관 제출용", value: "기관 제출용" },
        { text: "경력 증빙용", value: "경력 증빙용" },
        { text: "소득 증빙용", value: "소득 증빙용" },
        { text: "기타", value: "기타" }
      ],
      submitPlace: ""
    }
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"})
  },
  watch: {
    selectData(data) {
      if (data.value === "소득자료증명서") {
        this.setYearList();
      }
    }
  },
  methods: {
    setYearList() {
      const now = new Date();
      const nowYear = now.getFullYear();
      this.yearList = this.getYearList("2024", nowYear);
    },
    save() {
      this.showConfirm({
        message: `${this.selectData.text} 신청을 완료하시겠습니까?`,
        successCallback: () => {
          this.requestCertificate();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async requestCertificate() {
      const reqNote = `${this.dataConversion(this.usageList, this.usage)}/${this.submitPlace}`;
      const typeNm = this.selectData.value === "소득자료증명서" ? `${this.selectData.value}(${this.yyyy})` : this.selectData.value;
      await axiosInstance.post("/private/certificate/request", {}, {
        params: {
          reqId: this.memberId,
          certificateType: typeNm,
          reqNote: reqNote
        }
      }).then(() => {
        this.showAlert({
          message: "신청이 완료되었습니다",
          successCallback: () => {
            this.setDefaultData();
            this.$emit("close");
            this.$emit("refresh");
          }
        })
      }).catch((error) => {
        this.showAlert({message: `${error}`});
      })
    },
    setDefaultData() {
      this.usage = "";
      this.submitPlace = "";
      this.yyyy = "";
    },
    close() {
      this.setDefaultData();
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-title-layout {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 50px;
  .sub-title {
    font-size: 0.9rem;
  }
}
.input-container {
  margin: 50px 0;
  word-spacing: 12px;
}
.buttons-layout {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>